import script from "./StatementDept.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementDept.vue?vue&type=script&setup=true&lang=js"

import "./StatementDept.vue?vue&type=style&index=0&id=9f26247c&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f26247c"]])

export default __exports__